/* eslint-disable @typescript-eslint/no-explicit-any */
// ** React Imports
import { getUserData, getHomeRouteForLoggedInUser } from "@src/utility/Utils";
import { Suspense } from "react";
import { Navigate } from "react-router";

// ** Utils

const PublicRoute = ({ children, route }: any) => {
  if (route) {
    const user = getUserData();

    const restrictedRoute = route.meta && route.meta.restricted;

    if (user && restrictedRoute) {
      return <Navigate to={getHomeRouteForLoggedInUser(user.role)} />;
    }
  }

  return <Suspense fallback={null}>{children}</Suspense>;
};

export default PublicRoute;
